import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { Task } from 'ember-concurrency';
import { all, restartableTask } from 'ember-concurrency';
import type AgreementModel from 'garaje/models/agreement';
import type AgreementPageModel from 'garaje/models/agreement-page';
import type MetricsService from 'garaje/services/metrics';
import type StateService from 'garaje/services/state';
import type TrialService from 'garaje/services/trial';

interface FlowsSectionsLegalDocumentsListComponentSignature {
  Args: {
    agreementPage: AgreementPageModel;
    agreements: AgreementModel[];
    updateAndSaveTask: Task<void, [AgreementModel, string, boolean, boolean]>;
    trackFeatureToggled: (value: boolean) => void;
  };
}

export default class FlowsSectionsLegalDocumentsListComponent extends Component<FlowsSectionsLegalDocumentsListComponentSignature> {
  @service declare trial: TrialService;
  @service declare state: StateService;
  @service declare metrics: MetricsService;

  get legalDocumentsEnabled(): boolean {
    return this.args.agreementPage.enabled && !!this.state.features?.includesNda;
  }

  get hasAccessToIncludesNdaFeature(): boolean {
    return Boolean(this.state.features?.includesNda);
  }

  updateAgreementPositions = restartableTask(async (agreements: AgreementModel[]) => {
    await all(
      agreements.map((agreement, index) => {
        agreement.position = index + 1;
        // @ts-ignore custom save option
        return agreement.save({ propagable: false });
      }),
    );
  });

  @action
  toggleAgreementEnabled(agreement: AgreementModel, value: boolean): void {
    void this.args.updateAndSaveTask.perform(agreement, 'enabled', value, false);
  }

  @action
  toggleAgreementPageEnabled(agreementPage: AgreementModel, value: boolean): void {
    void this.args.updateAndSaveTask.perform(agreementPage, 'enabled', value, false);
    this.args.trackFeatureToggled(value);
  }
}
